import Vue from "vue";
import Vuetify from "vuetify/lib";
import { isThemeDark } from "@/common/lib/utils";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: isThemeDark(),
    options: {
      customProperties: true,
      variations: false,
    },
    themes: {
      light: {
        primary: "#f66033",
        warning: "#ffb21e",
        error: "#ff2020",
        success: "#4ad898",
        green: "#4AD898",
        purple: "#7387FF",
        smoke: "#fafafb",
        dark: "#4e4e4e",
        white: "#ffffff",
        black: "#000000",
      },
      dark: {
        primary: "#f66033",
        black: "#ffffff",
        white: "#161f29",
        dark: "#000000",
        success: "#4ad898",
        warning: "#ffb21e",
        error: "#ff2020",
        green: "#4AD898",
        purple: "#7387FF",
      },
    },
  },
});
